import { useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

// Returns the current Backstage user entity ref (e.g. "user:default/jane"),
// or null while the identity is being resolved or if it can't be read.
export const useCurrentUserRef = (): string | null => {
  const identityApi = useApi(identityApiRef);
  const [userRef, setUserRef] = useState<string | null>(null);
  useEffect(() => {
    identityApi
      .getBackstageIdentity()
      .then(id => setUserRef(id.userEntityRef ?? null))
      .catch(() => setUserRef(null));
  }, [identityApi]);
  return userRef;
};
